import { INoteRaw } from '@ftd/types'
import { Content } from '@tiptap/core'

import { BASE_URL } from '@/api/constants'
import { secureFetch } from '@/api/secure-fetch'

export const apiGetNotes = async (): Promise<INoteRaw[]> => {
  const res = await secureFetch(`${BASE_URL}/notes`)
  if (!res.ok) throw new Error('Failed to fetch notes')
  return res.json()
}

export const apiGetNotesBySession = async (sessionId: string): Promise<INoteRaw[]> => {
  const res = await secureFetch(`${BASE_URL}/notes/session/${sessionId}`)
  if (!res.ok) throw new Error('Failed to fetch notes for session')
  return res.json()
}

export const apiGetNote = async (noteId: string): Promise<INoteRaw> => {
  const res = await secureFetch(`${BASE_URL}/notes/${noteId}`)
  if (!res.ok) throw new Error('Failed to fetch note')
  return res.json()
}

export const apiGetPublicNote = async (publicId: string): Promise<INoteRaw> => {
  const res = await fetch(`${BASE_URL}/notes/public/${publicId}`, {
    cache: 'no-store',
  })

  if (!res.ok) throw new Error('Failed to fetch public note')
  return res.json()
}

export const apiCreateNote = async (data: {
  title: string
  content?: Content
  contentHtml?: string
  contentText?: string
  tags: string[]
  session?: string
}): Promise<INoteRaw> => {
  const res = await secureFetch(`${BASE_URL}/notes`, {
    method: 'POST',
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Failed to create note')
  return res.json()
}

export const apiUpdateNote = async (
  noteId: string,
  data: Partial<{
    title: string
    content: Content
    contentHtml: string
    contentText: string
    tags: string[]
    isPublic: boolean
  }>,
): Promise<INoteRaw> => {
  const res = await secureFetch(`${BASE_URL}/notes/${noteId}`, {
    method: 'PUT',
    body: JSON.stringify(data),
  })
  if (!res.ok) throw new Error('Failed to update note')
  return res.json()
}

export const apiDeleteNote = async (noteId: string): Promise<void> => {
  const res = await secureFetch(`${BASE_URL}/notes/${noteId}`, {
    method: 'DELETE',
  })
  if (!res.ok) throw new Error('Failed to delete note')
}

export const apiSearchNotes = async (params: {
  q?: string
  tags?: string[]
  sessionId?: string
}): Promise<INoteRaw[]> => {
  const searchParams = new URLSearchParams()
  if (params.q) searchParams.append('q', params.q)
  if (params.tags) params.tags.forEach((tag) => searchParams.append('tags', tag))
  if (params.sessionId) searchParams.append('sessionId', params.sessionId)

  const res = await secureFetch(`${BASE_URL}/notes/search?${searchParams.toString()}`)
  if (!res.ok) throw new Error('Failed to search notes')
  return res.json()
}
